import { Bento, BentoCell } from '../../components/Bento.js';
import { DocumentList } from '../../components/DocumentList.js';
import { useActor } from '../../lib/capabilities.js';

/**
 * Documents, for whichever portal actor is asking.
 *
 * One component for both audiences because there is nothing to branch on: the list is
 * unfiltered, and `documents_tenant_select` and `documents_owner_select` produce two
 * different answers to the identical request. The only difference on this page is the
 * sentence explaining what "shared with you" means.
 *
 * Downloads mint a presigned URL per click, after the row has been authorized through
 * the scoped client. Nothing here holds a URL — they are short-lived bearer
 * capabilities, and a page that pre-mints one per row leaves a handful of them in the
 * browser cache for the sake of saving a request nobody asked to save.
 */
export function PortalDocuments() {
  const actor = useActor();
  const isOwner = actor?.actorType === 'OWNER';

  return (
    <section>
      <h1>Documents</h1>
      <p className="muted">
        {isOwner
          ? 'Files the office has released to you, including for properties you no longer hold. If you are expecting something that is not here, please contact the property office.'
          : 'Your lease, notices, and checklists — anything the office has shared with you. If you are expecting something that is not here, please contact the property office.'}
      </p>

      <Bento>
        <BentoCell span="full">
          <DocumentList
            emptyMessage={
              isOwner
                ? 'Nothing has been shared your account yet.'
                : 'Nothing has been shared with you yet.'
            }
          />
        </BentoCell>

        <BentoCell span="full" title="Keeping your own copies">
          <p className="bento__hint">
            You can download your documents from this page for your records. Please note that links
            from this page may not work if shared.
          </p>
        </BentoCell>
      </Bento>
    </section>
  );
}
